module.exports = __webpack_public_path__ + "assets/img/main_background_home.9fd4bb4a.jpg";